import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import Sponsor from "../../common/Sponsor";
import JoinUs from "../../common/JoinUs";
import PricingCard from "./PricingCard";
import ServiceWraptwo from "./ServiceWraptwo";

function ServicePage() {
  return (
    <>
    <div className="background-image-unset bg-white">
      <Breadcrumb name="Our Services" />
      <ServiceWraptwo />
      {/* <PricingCard /> */}
      <JoinUs padding="pt-120" />
      <Sponsor />
      </div>
    </>
  );
}

export default ServicePage;
